export const SupportingDocumentSource = {
  FINISHED_PRODUCT_BATCH: 'FINISHED_PRODUCT_BATCH',
  FINISHED_PRODUCT_PRODUCTION_INSTRUCTION: 'FINISHED_PRODUCT_PRODUCTION_INSTRUCTION',
  RAW_MATERIAL_BATCH: 'RAW_MATERIAL_BATCH',
};

export const SupportingDocumentSourceList = {
  [SupportingDocumentSource.FINISHED_PRODUCT_BATCH]: 'Késztermék sarzs',
  [SupportingDocumentSource.FINISHED_PRODUCT_PRODUCTION_INSTRUCTION]: 'Késztermék gyártási utasítása',
  [SupportingDocumentSource.RAW_MATERIAL_BATCH]: 'Alapanyag sarzs',
};
